import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import ActionSave from 'material-ui/svg-icons/content/save';
import { fullWhite } from 'material-ui/styles/colors';

class ChargeCommentTextBox extends React.Component {

    constructor(props) {
        super(props);

        this.onCommentChange = this
            .onCommentChange
            .bind(this);
        this.onSave = this
            .onSave
            .bind(this);

    }

    onCommentChange(e) {
        const { chargeActions, orderId, charge } = this.props;
        chargeActions.chargeUpdateCancelled({
            billingSystemChargeID: charge.get('billingSystemChargeID')
        }, orderId);
        chargeActions.chargeCommentSet(charge.get('chargeID'), e.target.value, orderId);
    }

    onSave() {
        const { chargeActions, orderId, charge } = this.props;

        if (charge.get('transactionId') > 0) {
            chargeActions.chargeUpdateStarted({
                transactionID: charge.get('transactionId'),
                jobNumber: orderId,
                comment: charge.get('comment'),
                quantity: charge.get('quantity'),
                queueStatusTypeID: 1,
                billingSystemChargeID: charge.get('billingSystemChargeID')

            }, orderId);

        } else {
            chargeActions.chargeAddStarted({
                jobNumber: orderId,
                comment: charge.get('comment'),
                quantity: charge.get('quantity'),
                billingSystemChargeID: charge.get('billingSystemChargeID')

            }, orderId);
        }
    }

    render() {

        const { charge, hasUnsavedChanges, disabled } = this.props;

        if (!charge) {
            return null;
        }

        let saveButtonDisabled = true;

        if (hasUnsavedChanges && charge.get('isValid') && charge.get('requiresComment')) {

            saveButtonDisabled = false;
        }

        return (
            <div>
                <div>
                    <TextField
                        style={{
                            width: '100px'
                        }}
                        hintText="Comment"
                        disabled={disabled}
                        value={charge.get('comment') ? charge.get('comment') : null}
                        floatingLabelText="Enter Comment"
                        onChange={this.onCommentChange}
                        multiLine={true}
                        rows={2}
                        maxLength="70" />
                </div>
                <div>
                    <RaisedButton
                        disabled={saveButtonDisabled}
                        onTouchTap={this.onSave}
                        primary
                        fullWidth
                        label="Save"
                        icon={(<ActionSave color={fullWhite} />)} />
                </div>
            </div>
        );
    }
}

ChargeCommentTextBox.propTypes = {
    charge: PropTypes.object,
    chargeActions: PropTypes.object,
    orderId: PropTypes.string,
    hasUnsavedChanges: PropTypes.bool,
    disabled: PropTypes.bool

};
export default ChargeCommentTextBox;


// WEBPACK FOOTER //
// ./src/components/charges/ChargeCommentTextBox.js